// test1094
(1094 && 0);
